<template>
  <!-- a page anyone may open (the sign-up page): no staff login, no menu, and
       shown whether or not a staff user is signed in in this tab -->
  <div class="container py-3">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-10 col-xl-9">
        <!-- keyed on the path: another company's link opens its own page afresh -->
        <router-view :key="$route.path" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "PublicLayout",
});
</script>
